import Home from 'pages/home';
import DashboardRoutes from 'build/dashboard-routes';

const routes = [
  {
    path: '/',
    component: Home,
    name: 'panel',
  },
  ...DashboardRoutes,
];

export default routes;
